import { IApplicationState } from '../../types/redux';

/**
 * Выбирает подобные статьи
 */
export const selectSimilarArticles = ({ similarArticles }: IApplicationState) => similarArticles.items;
